import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {Input} from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import {BeatLoader} from 'react-spinners';
import {css} from "@emotion/core";

import leftBackImg from "../assets/img/landing_back.png";
import "../assets/css/store-register.css";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    color: white;
    text-align:center;
`;
const queryString = require('query-string');

/*
 * Self-registration for store users invited by Ops.
 *
 * The invite link carries a signed token holding the invitee's email and store,
 * so this page only asks for the name and phone - user type, group, sub group,
 * access flags and login type are all fixed server side.
 *
 * Submitting registers *and* approves the account, which mails out the login
 * credentials together with an activation link. The invitee activates from that
 * link and signs in there - this page does not ask for a password.
 */
class StoreRegister extends Component {
    constructor() {
        super();

        this.state = {
            token: '',
            // 'loading' | 'form' | 'done' | 'error'
            stage: 'loading',
            statusMessage: '',
            submitting: false,
            errors: '',

            storeName: '',
            contact_title: '',
            firstName: '',
            lastName: '',
            phone: '',
            email: ''
        };

        this.onChange = this.onChange.bind(this);
        this.onRegister = this.onRegister.bind(this);
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        const token = parsed.token || '';
        this.setState({token: token});

        axios.post(config.get('API_URL') + '/users/store_invite_info', {token: token})
            .then(response => {
                const data = response.data;
                if (data.status === 'ok') {
                    this.setState({
                        stage: 'form',
                        storeName: data.store_name,
                        email: data.email,
                        contact_title: data.contact_title || '',
                        firstName: data.first_name || '',
                        lastName: data.last_name || '',
                        phone: data.phone || ''
                    });
                } else if (data.status === 'already_registered') {
                    alert("Your account is already registered. Please login.");
                    window.location.href = "/";
                } else if (data.status === 'expired') {
                    this.setState({
                        stage: 'error',
                        statusMessage: "Your registration link has expired. Please contact support@innoviti.com for a new invite."
                    });
                } else {
                    this.setState({
                        stage: 'error',
                        statusMessage: "This registration link is not valid."
                    });
                }
            })
            .catch(() => {
                this.setState({
                    stage: 'error',
                    statusMessage: "This registration link is not valid."
                });
            });
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    onChangePhone(e) {
        if (isNaN(e.target.value)) {
            return;
        }
        this.setState({phone: e.target.value});
    }

    onRegister(e) {
        e.preventDefault();

        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const phone = this.state.phone.replace(/[^0-9]/g, '');
        if (phone.length > 0 && phone.length !== 10) {
            this.setState({errors: "Phone number should 10 digit."});
            return;
        }

        // Fields stay disabled while the account is being created.
        this.setState({submitting: true, errors: ''});

        axios.post(config.get('API_URL') + '/users/store_register', {
            token: this.state.token,
            contact_title: this.state.contact_title,
            firstName: this.state.firstName.trim(),
            lastName: this.state.lastName.trim(),
            phone: phone
        }).then(response => {
            if (response.data.status === 'ok') {
                this.setState({stage: 'done', submitting: false, phone: phone});
            } else {
                this.setState({
                    submitting: false,
                    errors: response.data.error || "Something went wrong. Please try again."
                });
            }
        }).catch(err => {
            const message = err.response && err.response.data && err.response.data.error
                ? err.response.data.error
                : "Something went wrong. Please try again.";
            this.setState({submitting: false, errors: message});
        });
    }

    renderRegisterForm() {
        const disabled = this.state.submitting;
        return (
            <form className="" method="POST" onSubmit={this.onRegister}>
                <div className="card-heading">
                    <h3>Complete your registration</h3>
                    <p>Tell us who you are. Your store and email are already set
                        from your invitation.</p>
                </div>
                <div className="form-group fixed-field">
                    <label>Store Name</label>
                    <Input type="text" className="form-control logon-input"
                           value={this.state.storeName} disabled={true} readOnly/>
                </div>
                <div className="form-group fixed-field">
                    <label>Email<span className="star">*</span></label>
                    <Input type="text" className="form-control logon-input"
                           value={this.state.email} disabled={true} readOnly/>
                    <span className="fixed-hint">Your password will be sent here.</span>
                </div>
                <div className="form-group">
                    <label>Title<span className="star">*</span></label>
                    <select name="contact_title" className="form-control logon-input"
                            value={this.state.contact_title} onChange={this.onChange}
                            disabled={disabled}>
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Ms">Ms</option>
                    </select>
                    {this.validator.message('title', this.state.contact_title, 'required')}
                </div>
                <div className="field-row">
                    <div className="form-group">
                        <label>First Name<span className="star">*</span></label>
                        <Input placeholder="First Name" name="firstName" type="text"
                               className="form-control logon-input" value={this.state.firstName}
                               onChange={this.onChange} disabled={disabled}/>
                        {this.validator.message('first name', this.state.firstName, 'required')}
                    </div>
                    <div className="form-group">
                        <label>Last Name</label>
                        <Input placeholder="Last Name" name="lastName" type="text"
                               className="form-control logon-input" value={this.state.lastName}
                               onChange={this.onChange} disabled={disabled}/>
                    </div>
                </div>
                <div className="form-group">
                    <label>Phone</label>
                    <Input placeholder="10 digit mobile number" name="phone" type="text"
                           className="form-control logon-input" maxLength="10"
                           value={this.state.phone}
                           onChange={this.onChangePhone.bind(this)} disabled={disabled}/>
                </div>
                <div className="form-group">
                    {this.state.errors !== '' &&
                    <span className="errmsg">{this.state.errors}</span>}
                    <button type="submit" className="btn btn-lg btn-primary btn-block btn-login"
                            disabled={disabled}>
                        {disabled ? 'Registering...' : 'Register'}
                    </button>
                </div>
                <div className='sweet-loading'>
                    <BeatLoader css={override} sizeUnit={"px"} size={10}
                                color={'#123abc'} loading={this.state.submitting}/>
                </div>
            </form>
        );
    }

    /*
     * Registration is done, activation is not: it happens from the link in the
     * mail, so this hands the invitee off to their inbox rather than to a
     * password prompt here.
     */
    renderDone() {
        return (
            <div className="register-done">
                <div className="card-heading">
                    <h3>Check your email</h3>
                </div>
                <p className="register-note">Your registration for <b>{this.state.storeName}</b> is
                    complete. We have emailed your password and an activation link
                    to <b>{this.state.email}</b>.</p>
                <p className="register-note">Open the activation link to activate your account and
                    sign in for the first time.</p>
            </div>
        );
    }

    render() {
        const leftBackground = {
            backgroundImage: "url(" + leftBackImg + ")"
        };

        return (
            <div className="content-msg authFrom store-register">
                <div className="col-md-6 col-sm-12 no-padd auth-left-background" style={leftBackground}>
                    <div className="welcome-text">
                        <h2>Welcome to Sparcs</h2>
                        <h5>{this.state.stage === 'done'
                            ? 'Check your email to activate'
                            : 'Please complete your registration'}</h5>
                    </div>
                </div>
                <div className="col-md-6 col-sm-12 no-padd auth-right-background">
                    <div className="login-card">
                        <div className="welcome-text-mobile">
                            <h3>Welcome to Sparcs</h3>
                            <h5>{this.state.stage === 'done'
                                ? 'Check your email to activate'
                                : 'Please complete your registration'}</h5>
                        </div>
                        <div>
                            <div className='sweet-loading'>
                                <BeatLoader css={override} sizeUnit={"px"} size={10}
                                            color={'#123abc'}
                                            loading={this.state.stage === 'loading'}/>
                            </div>
                            {this.state.stage === 'form' && this.renderRegisterForm()}
                            {this.state.stage === 'done' && this.renderDone()}
                            {this.state.stage === 'error' &&
                            <div className="acivation_err">{this.state.statusMessage}</div>}
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

export default StoreRegister;
